import { FaInstagramSquare, FaLinkedin } from "react-icons/fa";
import "./socials.css";

export default function Socials({
  theme,
  position,
}: {
  theme: string;
  position: string;
}) {
  return (
    <div className={`ae-nav-socials-container -${theme} -${position}`}>
      <a href="https://www.linkedin.com/company/actedutrain1/about/" className="ae-nav-social-icon" target="_blank" rel="noreferrer" aria-label="Go to the LinkedIn page">
        <FaLinkedin />
      </a>
      <a href="https://www.instagram.com/actedutrain" target="_blank" rel="noreferrer" className="ae-nav-social-icon" aria-label="Go to the Instagram page">
        <FaInstagramSquare />
      </a>
    </div>
  );
}
